module.exports = __webpack_public_path__ + "static/logo-footer-574a774085d91f7fcd85dd52c6d3acbb.svg";